import { render, staticRenderFns } from "./po_send.vue?vue&type=template&id=25ed9f8f&scoped=true&"
import script from "./po_send.vue?vue&type=script&lang=js&"
export * from "./po_send.vue?vue&type=script&lang=js&"
import style0 from "./po_send.vue?vue&type=style&index=0&id=25ed9f8f&scoped=true&lang=less&"
import style1 from "./po_send.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ed9f8f",
  null
  
)

export default component.exports